import React from "react";
import { i18n } from "@euroland/libs";

import { formatDate } from "@euroland/libs";
import { getCurrencyLabel } from "../../store/utils";
import { DATE_SCREEN_READER } from "../../constant/common";
import useCurrencyName from "../../hooks/useCurrencyName";
import { formatNumberByInstrument } from "../../utils/format-number";

const QuadrataShowSingleItem = ({ historicalShare = {}, onClose }) => {
  const getCurrencyName = useCurrencyName();
  const instrumentId = historicalShare.instrumentId;
  return (
    <div className="quadrata-view-history">
      <button className="quadrata-view-history__close" onClick={onClose}>
        <span aria-hidden="false" aria-label="Close card" role="button" className="fs-close fs-icon"></span>
      </button>

      <p
        className="quadrata-view-history__title"
        aria-label={formatDate(historicalShare.date, "", DATE_SCREEN_READER)}
        role="note"
      >
        {formatDate(historicalShare.date, "shortDate")}
      </p>

      <div className="quadrata-view-history__row">
        <div className="quadrata-view-history__col nth-col-1">
          <div className="quadrata-view-history__item">
            <div className="quadrata-view-history__name">{i18n.translate("open")}</div>
            <div className="quadrata-view-history__value">
              {formatNumberByInstrument(historicalShare.open, instrumentId)}
            </div>
          </div>
          <div className="quadrata-view-history__item">
            <div className="quadrata-view-history__name">{i18n.translate("dayLow")}</div>
            <div className="quadrata-view-history__value">
              {formatNumberByInstrument(historicalShare.low, instrumentId)}
            </div>
          </div>
        </div>
        <div className="quadrata-view-history__col nth-col-1">
          <div className="quadrata-view-history__item">
            <div className="quadrata-view-history__name">{i18n.translate("volume")}</div>
            <div className="quadrata-view-history__value">
              {formatNumberByInstrument(historicalShare.volume, instrumentId, { decimalDigits: 0 })}
            </div>
          </div>
          <div className="quadrata-view-history__item">
            <div className="quadrata-view-history__name">{i18n.translate("closePrice")}</div>
            <div className="quadrata-view-history__value">
              {formatNumberByInstrument(historicalShare.close, instrumentId)}
            </div>
          </div>
        </div>
        <div className="quadrata-view-history__col">
          <div className="quadrata-view-history__item">
            <div className="quadrata-view-history__name">{i18n.translate("dayHigh")}</div>
            <div className="quadrata-view-history__value">
              {formatNumberByInstrument(historicalShare.high, instrumentId)}
            </div>
          </div>
          <div className="quadrata-view-history__item">
            <div className="quadrata-view-history__name">{i18n.translate("currency")}</div>
            <div
              className="quadrata-view-history__value"
              aria-label={getCurrencyName(historicalShare.currency)}
              role="note"
            >
              {getCurrencyLabel(historicalShare.currency)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuadrataShowSingleItem;
